import DatabaseService from 'services/DatabaseService.js';
import {SET_SURVEYS} from 'actions/types';
import {getSurveys, isListLoaded}  from 'reducers/surveys.js';

//Action Creators
export const setSurveys = (surveys, count) => {
    return { type:SET_SURVEYS, surveys:surveys, count: count };
}

//Thunks
export const fetchSurveys = (params, force) => (dispatch, getState) => {

    if (params.query && params.query !== '' && params.queryField !== '') {
        if (Array.isArray(params.queryField)) {
            for (var i in params.queryField) {
                params[`like.${params.queryField[i]}`] = params.query
            }
            delete params.query
        } else {
            params[`like.${params.queryField}`] = params.query
        }
    }

    if(!force) {
        var state = getState();
        if(isListLoaded(state.surveys)) {
            return Promise.resolve(getSurveys({data: state.surveys, count: state.count}));
        }
    }
    
    return new Promise(function(resolve, reject) {
        DatabaseService.getSurveys(params).then(
            function(result){ 
                console.log(result)
                result.surveys = result.surveys.map(survey => {
                    return {
                        image: survey.asset?.url,
                        title: survey.title,
                        fields: survey && [{
                            label: 'Tag',
                            text: survey.tag,
                        }],
                        category: survey.surveyCategory?.name,
                        description: survey.tag,
                        ...survey
                    }
                })
                dispatch(setSurveys(result.surveys, result.totalSurveys))
                resolve({data: result.surveys, count: result.totalSurveys})
            },
            function(error){ 
                console.error(error);
                reject(error); 
            });
    });
}
